module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Stairs-455246d89c510a59e4370bca826da08f.svg";